export const CardPointeTerminalSaleOutcome = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    CANCELED: 'canceled',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CardPointeTerminalSaleOutcome =
    (typeof CardPointeTerminalSaleOutcome)[keyof typeof CardPointeTerminalSaleOutcome];

export interface CardPointeTerminalSaleAuthorizationBody {
    readonly respstat: 'A' | 'C';
    readonly amount?: string;
    readonly resptext?: string;
    readonly authcode?: string;
    readonly respcode?: string;
    readonly merchid?: string;
    readonly cvvresp?: string;
    readonly retref?: string;
    readonly avsresp?: string;
    readonly respproc?: string;
    readonly batchid?: string;
    readonly token?: string;
    readonly account?: string;
    readonly expiry?: string;
    readonly name?: string;
    readonly binInfo?: unknown;
    readonly emvTagData?: unknown;
    readonly tokenExpired?: boolean;
    readonly entrymode?: string;
    readonly bintype?: string;
    readonly orderId?: string;
    readonly receiptData?: unknown;
    readonly fee_amount?: string;
    readonly fee_value?: string;
    readonly fee_type?: 'SURCHRG' | 'SURCHRG_WAIVED';
    readonly fee_format?: 'percent' | '';
    readonly fee_authcode?: string;
    readonly fee_merchid?: string;
    readonly fee_retref?: string;
}

export interface CardPointeTerminalSaleErrorBody {
    readonly errorCode: string;
    readonly errorMessage: string;
    readonly authResponse?: CardPointeTerminalSaleAuthorizationBody;
}

export type CardPointeTerminalSaleResponseDetails =
    | {
          readonly outcome: typeof CardPointeTerminalSaleOutcome.APPROVED;
          readonly httpStatus: 200;
          readonly body: CardPointeTerminalSaleAuthorizationBody & {
              readonly respstat: 'A';
              readonly retref: string;
              readonly amount: string;
              readonly merchid: string;
          };
      }
    | {
          readonly outcome: typeof CardPointeTerminalSaleOutcome.DECLINED;
          readonly httpStatus: 200;
          readonly body: CardPointeTerminalSaleAuthorizationBody & {
              readonly respstat: 'C';
              readonly resptext: string;
          };
      }
    | {
          readonly outcome: typeof CardPointeTerminalSaleOutcome.CANCELED;
          readonly httpStatus: number;
          readonly body: CardPointeTerminalSaleErrorBody;
      }
    | {
          readonly outcome: typeof CardPointeTerminalSaleOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly body: unknown;
          readonly message: string;
      };
